/* eslint-disable no-unused-vars */
import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { useTailwindBrand } from '../../Components/shared';

interface OnboardingStepperProps {
    steps: string[];
    /** Étape active (1-indexée). */
    activeStep: number;
    /** Navigation vers une étape déjà franchie (les étapes futures ne sont pas cliquables). */
    onStepClick?: (step: number) => void;
}

/**
 * Rail de progression du parcours AICI : liste verticale sur grand écran,
 * barre de progression horizontale sur mobile. Typé, sans plafond de navigation
 * (contrairement au Stepper Admin legacy). Seules les étapes passées sont cliquables.
 */
const OnboardingStepper = ({ steps, activeStep, onStepClick }: OnboardingStepperProps) => {
    const { classes, brandConfig } = useTailwindBrand();
    const primary = brandConfig.colors.primary;

    return (
        <div className={`${classes.fontFamily}`}>
            {/* ── Mobile : barre horizontale ── */}
            <div className="flex items-center gap-2 lg:hidden">
                {steps.map((_, i) => {
                    const idx = i + 1;
                    const done = idx < activeStep;
                    const active = idx === activeStep;
                    return (
                        <div
                            key={i}
                            className="h-1.5 flex-1 rounded-full transition-colors"
                            style={{ backgroundColor: done || active ? primary : '#E5E7EB' }}
                        />
                    );
                })}
            </div>
            <p className={`mt-3 text-sm font-bold lg:hidden ${classes.primaryText}`}>
                Étape {activeStep} / {steps.length} {steps[activeStep - 1]}
            </p>

            {/* ── Desktop : liste verticale ── */}
            <ol className="hidden lg:flex lg:flex-col lg:gap-1">
                {steps.map((label, i) => {
                    const idx = i + 1;
                    const done = idx < activeStep;
                    const active = idx === activeStep;
                    const clickable = done && !!onStepClick;
                    return (
                        <li key={i}>
                            <button
                                type="button"
                                disabled={!clickable}
                                onClick={() => clickable && onStepClick?.(idx)}
                                className={`flex items-center w-full gap-3 px-3 py-3 rounded-xl text-left transition-colors ${active ? 'bg-gray-50' : ''
                                    } ${clickable ? 'cursor-pointer hover:bg-gray-50' : 'cursor-default'}`}
                            >
                                <span
                                    className="flex items-center justify-center w-8 h-8 text-sm font-bold text-white rounded-full shrink-0"
                                    style={{
                                        backgroundColor: done || active ? primary : '#D1D5DB',
                                    }}
                                >
                                    {done ? <CheckIcon sx={{ fontSize: 18 }} /> : idx}
                                </span>
                                <span
                                    className={`text-sm font-semibold ${active ? classes.primaryText : done ? classes.text : 'text-gray-400'
                                        }`}
                                >
                                    {label}
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

export default OnboardingStepper;
